import { render } from "./thumbnail.vue?vue&type=template&id=a9b42370&scoped=true"
import script from "./thumbnail.vue?vue&type=script&lang=js"
export * from "./thumbnail.vue?vue&type=script&lang=js"

import "./thumbnail.vue?vue&type=style&index=0&id=a9b42370&scoped=true&lang=css"

import exportComponent from "/var/www/__kickoff-23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b42370"]])

export default __exports__